import React, { useContext } from 'react'
import { WidgetContext } from '../../Widget2'

const CalendarSelector = ({ userAppointmentCalendars, onCalendarSelect }) => {
  const { franchise } = useContext(WidgetContext)
  const { primaryColor, contrastColor } = franchise.attributes
  
  return (
    <div className="appointment-scheduler-calendar-selector">
      <div className="appointment-scheduler-calendar-selector-content">
        { userAppointmentCalendars.map(userAppointmentCalendar => 
        <div key={userAppointmentCalendar.id} className="appointment-scheduler-calendar-selector-item">
          <h1>{ userAppointmentCalendar.attributes.title }</h1>
          <div className="appointment-scheduler-overview-meta">{ userAppointmentCalendar.attributes.defaultLengthInMinutes } minutes</div>
          <div className="mt-3">
            <div className="ql-content-wrapper" dangerouslySetInnerHTML={{ __html: userAppointmentCalendar.attributes.invitationMessageHtml }} />
          </div>
          <button style={{ backgroundColor: primaryColor, borderColor: primaryColor, color: contrastColor }} className="btn btn-primary btn-sm" onClick={() => onCalendarSelect(userAppointmentCalendar)}>Schedule</button>
        </div>
        )}
      </div>
    </div>
  )
}

export default CalendarSelector
